interface MoveImageCacheState {
  cache: { [key: string]: any };
}

const initialState: MoveImageCacheState = {
  cache: {},
};

/**
 * moveImageCacheReducer: Reducer to handle actions related to caching moveImageHumanVerification API responses.
 *
 * @param {MoveImageCacheState} state - The current state of the move image cache.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {MoveImageCacheState} The new state after applying the action.
 */
const moveImageCacheReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_MOVE_IMAGE_CACHE":
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.payload.key]: action.payload.data,
        },
      };
    default:
      return state;
  }
};

export default moveImageCacheReducer;